var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NotificationMessage',{staticClass:"notification"}),_c('div',{staticClass:"layout"},[_c('CrudDesks',{staticClass:"crud-data-table",attrs:{"center":_vm.center,"room":_vm.room,"desks":_vm.desks}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }